import { useEffect } from "react";
import styles from "./style.module.scss";
import PageContainer from "@components/layout/PageContainer";
import { useParams } from "react-router-dom";
import { CustomFieldsTemplateIds, TYPE_OF_DOCUMENTS } from "../CustomFields";
import CustomFieldForm from "@components/forms/CustomFieldForm";

const CustomField = () => {
  const params = useParams()
  const { templateId } = params

  useEffect(() => {
  }, []);

  return (
    <PageContainer
      title="Actualizar Informacion personalizada"
      backUrl="/user/custom-fields"
      primaryActions={[
        {
          actionTitle: "Guardar",
          formId: "customFields",
          type: "submit",
          color: "success"
        }
      ]}
    >
      {templateId && (
        <>
          <h2> Informacion personalizada de  <b>{TYPE_OF_DOCUMENTS[templateId as CustomFieldsTemplateIds]}</b></h2>
          <CustomFieldForm
            formId="customFields"
            templateId={templateId as CustomFieldsTemplateIds}
            saveRedirectUrl="/user/custom-fields"
          />
        </>
      )}

    </PageContainer>
  );
}

export default CustomField;
